import React from "react";
import { AppLayout, PageHeader } from "@/components/AppLayout";
import { can } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { TariffModel } from "@/components/TariffModel";

export default function CostDashboard() {
  const { user } = useAuth();
  const canEdit = can(user?.role, "costdash:update");
  return (
    <AppLayout>
      <PageHeader
        title="Cost Dashboard"
        subtitle="Tariff model — Logisticon per m³ (Estcourt). All amounts exclude 15% VAT."
      />
      <TariffModel canEdit={canEdit} />
    </AppLayout>
  );
}
